<smt-workflow-header></smt-workflow-header>

<div class="content-inner" [class.loading]="loading">
  <div class="workflow-section-heading">Select a Cost Center</div>
  <ul class="button-list">
    <li *ngFor="let costCenter of list">
      <a class="button" [class.active]="service.current && costCenter.id === service.current.id" [routerLink]="routerLink()" [queryParams]="queryParams(costCenter.id)">
        {{costCenter.name}} - {{costCenter.number}}
      </a>
    </li>
  </ul>
</div>